import { useCallback } from 'react'
import { useModalStore } from 'hooks/stores/useModalStore'
import { LazyComponentWrapper } from 'components/LazyComponentWrapper/LazyComponentWrapper'
import { ReviewsAnythingWizard } from '../components/ReviewsWizard/ReviewsAnythingWizard'
import { AlmanacFile, PropsType } from 'types'

interface ReviewsWizardProps {
  closeModal: () => void
  onGoBack: () => void
  overrideFolder?: AlmanacFile | null
}

export const ReviewsWizardWrapper = ({ onGoBack, overrideFolder }: ReviewsWizardProps) => {
  return (
    <LazyComponentWrapper component={<ReviewsAnythingWizard onGoBack={onGoBack} overrideFolder={overrideFolder} />} />
  )
}

const useReviewCreationModal = () => {
  const { openModal, closeModal } = useModalStore()

  const openReviewModal = useCallback(
    (modalProps?: PropsType<typeof ReviewsWizardWrapper>) => {
      return openModal(ReviewsWizardWrapper, { modalProps, customModal: true })
    },
    [openModal],
  )

  const closeReviewModal = useCallback((_?: object) => closeModal(), [closeModal])

  return {
    openReviewModal,
    closeReviewModal,
  }
}

export default useReviewCreationModal
